import { FormHelperText, Grid, Rating as MRating, SvgIcon } from '@mui/material'
import React from 'react'

import { PinnedIcon, UnpinnedIcon } from '../../../assets/icons'
import colors from '../../../theme/colors'

const StyledRating = React.forwardRef((props: any, ref: React.Ref<any>) => (
  <MRating
    ref={ref}
    {...props}
    sx={theme => ({
      '& .MuiRating-iconFilled': {
        color: colors.petrol
      },
      '& .MuiRating-iconEmpty': {
        color: theme.palette.grey[400]
      }
    })}
  />
))
interface RatingProps {
  max?: number
  value?: number
  precision?: number
  name?: string
  onChange(event: React.SyntheticEvent<Element, Event>, value: number | null): void
  readOnly?: boolean
  disabled?: boolean
  helperText?: string
  error?: any
  id?: string
}

const Rating = React.forwardRef<React.ReactElement, RatingProps>(
  (
    { max = 5, name, onChange, precision = 1, readOnly, value, disabled, helperText, error, id },
    ref
  ) => (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <StyledRating
          id={id}
          ref={ref}
          max={max}
          name={name}
          onChange={onChange}
          precision={precision}
          readOnly={readOnly}
          value={value}
          icon={<SvgIcon component={PinnedIcon} />}
          emptyIcon={<SvgIcon component={UnpinnedIcon} />}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <FormHelperText error={!!error}>{helperText}</FormHelperText>
      </Grid>
    </Grid>
  )
)

export default Rating
